import { Navigate } from "react-router-dom";
import { getTokenRole } from "../../utils/auth";

/**
 * role에 따라 적절한 페이지로 리다이렉트하는 컴포넌트
 * student는 /my_exams로, admin은 /exam_papers로 리다이렉트
 */
const RoleBasedRedirect = () => {
  const role = getTokenRole();

  if (role === "student") {
    return <Navigate to="/my_exams" replace />;
  } else if (role == "admin") {
    return <Navigate to="/exam_papers" replace />;
  }

  // role이 없는 경우 (토큰이 없는 경우)는 ProtectedRoute에서 처리됨
  return <Navigate to="/login" replace />;
};

export default RoleBasedRedirect;
